import { Injectable } from '@angular/core';
import { _baseUrl, GlobalService } from '../../helper/global-helper';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InOutRetrievalService {

  baseUrl: string;
  private line: string = '';

  constructor(private http: HttpClient, private global: GlobalService) {
    this.baseUrl = _baseUrl;
    this.global.machineInfos.subscribe({
      next: newValue => {
        this.line = newValue.line;
      }
    });
  }

  /**
   * Function fetches pins and their labels for all ecus (currently general, in future dependent on machine)
   * 
   * @returns json with all ecus, names, pins and labels
   */
  public getPinLabels() {
    return this.http.get(this.baseUrl + 'ecupinlabels?productline=' + this.line + 'line', {
      observe: 'response',
      responseType: 'json',
    });
  }

  /**
   * Function fetches pin data for ecu and returns in a json
   * 
   * @param ecu_id 
   * @returns json with all pins and their data for this ecu
   */
  public getPinData(ecu_id: number){
    return this.http.get(this.baseUrl + 'dataresource/ecupinio?ecuid=' + ecu_id, {
      observe: 'response',
      responseType: 'json',
    });
  }
}

export type TableDataPointInput = {
  "id": string,
  "label": string,
  "di": string | number | null,
  "aiv": number | null,
  "ri": number | null,
  "fi": number | null,
  "aic": number | null
}

export type TableDataPointOutput = {
  "id": string,
  "label": string,
  "po": number | null,
  "do": string | number | null,
  "aov": number | null
}

export type Ecus = {
  'name': string,
  'id': number,
  'expanded': boolean
}

export type Example = {
    "ecu_id": number,
    "input_pins": [{
        "id": string,
        "di": string | null,
        "aiv": number | null,
        "ri": number | null,
        "fi": number | null,
        "aic": number | null
    }],
    "output_pins": [{
        "id": string,
        "po": number | null,
        "do": string | null,
        "aov": number | null
    }]
}

export type PinLabel = {
    "ecu_id": number,
    "ecu_name"?: string,
    "pins": [{
        "id": string,
        "label": string
    }]
}
